import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { initBannerAnimation } from "../../vendor/bannerAnimation";
import withFullHeightScreen from "../../hocs/withFullHeightScreen";
import withScrollDown from "../../hocs/withScrollDown";
import {Link} from "gatsby";
import createValidLink from "../../helpers/urlFixer";

const Banner = ({ title, minHeight, getReference, extraLinkText, extraLinkUrl }) => {
	const banner = useRef(null);

	useEffect(() => {
		initBannerAnimation(banner.current);
	}, [banner]);

	const getBanner = ref => {
		banner.current = ref;

		getReference(ref);
	}

	const extraLink = createValidLink(extraLinkUrl);

	return (
		<section
			className="banner"
			ref={getBanner}
			style={{
				minHeight: minHeight
			}}
		>
			<div className="banner__wrapper container">
				<div className="banner__content">
					<div className="banner__header">
						<h2 className="banner__title section-title">
							{title}
						</h2>

						{extraLinkText && extraLinkUrl && (
							<div className="banner__link-wrapper">
								<Link className="banner__link" to={extraLink}>
									{extraLinkText}
								</Link>
							</div>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

Banner.propTypes = {
	title: PropTypes.string.isRequired,
	minHeight: PropTypes.string.isRequired,
	scrollDown: PropTypes.func.isRequired,
	getReference: PropTypes.func.isRequired
};

export default withFullHeightScreen(
	withScrollDown(
		Banner
	)
);
